// @ts-nocheck
const SUB_PLAN_HOST_IDS  = [15541733032260, 15295053496644];
const SELLING_PLAN_ONE   = 698068140356;
const SELLING_PLAN_TWO   = 698068304196;

// Skin Corrector offer: the plan follows the number of bottles (1 = monthly, 2-3 = every 2 months, 4+ = every 4 months).
const SCP_PRODUCT_IDS = [15295053496644, 15689888727364, 15621417795908];
const SCP_PLANS = { 1: 698857390404, 2: 698857619780, 4: 698857652548 };
const SCP_PLAN_IDS = Object.values(SCP_PLANS);
const SPONGE_VARIANT_ID = 56364702204228;

function scpMonthsFor(quantity) {
  return quantity >= 4 ? 4 : quantity >= 2 ? 2 : 1;
}

// Sponge plan for a delivery interval: always the same Klyr New Selling Plan as the bottles,
// so bottles and sponges end up in one subscription and ship together.
window.klyrSpongePlan = async (months) => SCP_PLANS[months] || null;

// Old sponge plans (Klyr Selling Plan - 10%) -> interval in months.
const OLD_SPONGE_PLAN_MONTHS = { 698187252036: 1, 698187284804: 2, 698401259844: 2, 698401292612: 4 };

class CustomCartDrawer {
  constructor(drawerSelector) {
    this.drawer = document.querySelector(drawerSelector);

    if (!this.drawer) {
      console.error("Cart drawer not found.");
      return;
    }

    this.initEvents();

    // Listen to cart updates (from ATCManager, FreeProductManager, or drawer actions)
    document.addEventListener('cart:updated', (e) => {
      this.rerenderCart(e.detail); // <-- rerender cart whenever cart:updated is emitted
    });
  }

  initEvents() {
    this.drawer.addEventListener('click', (e) => {
      // Plus / Minus buttons
      if (e.target.matches('[data-qty-plus], [data-qty-minus]')) {
        const row   = e.target.closest('[data-cart-item]');
        const input = row?.querySelector('[data-quantity-input]');
        const lineKey = row?.dataset.lineKey;
        if (!input || !lineKey) return;

        let value = parseInt(input.value, 10) || 1;
        if (e.target.hasAttribute('data-qty-plus')) value++;
        else if (e.target.hasAttribute('data-qty-minus') && value > 0) value--;

        input.value = value;
        this.updateQuantity(lineKey, value, row);
      }

      // Remove button
      if (e.target.closest('[data-remove-item]')) {
        const row     = e.target.closest('[data-cart-item]');
        const lineKey = row?.dataset.lineKey;
        if (lineKey) this.updateQuantity(lineKey, 0, row);
      }
    });

    // Direct input change
    this.drawer.addEventListener('change', (e) => {
      if (e.target.matches('[data-quantity-input]')) {
        const row     = e.target.closest('[data-cart-item]');
        const lineKey = row?.dataset.lineKey;
        const quantity = parseInt(e.target.value, 10);
        if (lineKey && !isNaN(quantity)) this.updateQuantity(lineKey, quantity, row);
      }
    });
  }

  toggleLoader(lineKey, show) {
    const itemRow = this.drawer.querySelector(`[data-line-key="${lineKey}"]`);
    if (itemRow) {
      const loader = itemRow.querySelector('.loading-overlay');
      if (loader) {
        if (show) loader.classList.remove('loader-hidden');
        else loader.classList.add('loader-hidden');
      }
    }
  }

  post(url, body) {
    return fetch(`${window.Shopify.routes.root}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // Swap a line to another selling plan. If the new plan can't be added, the original line is put back.
  async switchPlan(line, quantity, plan) {
    const original = { id: line.variant_id, quantity: line.quantity, properties: line.properties || {} };
    if (line.selling_plan_allocation) original.selling_plan = line.selling_plan_allocation.selling_plan.id;
    await this.post('cart/change.js', { id: line.key, quantity: 0 });
    const item = { id: line.variant_id, quantity, properties: line.properties || {} };
    if (plan) item.selling_plan = plan;
    const res = await this.post('cart/add.js', { items: [item] });
    if (!res.ok) {
      original.quantity = quantity;
      await this.post('cart/add.js', { items: [original] });
    }
  }

  async updateScpQuantity(lineKey, quantity) {
    const cart = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' }).then(r => r.json());
    const line = cart.items.find(item => item.key === lineKey);
    const currentPlan = line?.selling_plan_allocation?.selling_plan.id;
    const months = scpMonthsFor(quantity);
    const correctPlan = SCP_PLANS[months];

    if (!line || quantity <= 0 || !SCP_PLAN_IDS.includes(currentPlan) || currentPlan === correctPlan) {
      await this.post('cart/change.js', { id: lineKey, quantity });
    } else {
      await this.switchPlan(line, quantity, correctPlan);
      // Subscribed sponges follow the new delivery interval of the bottles.
      const spongePlan = await window.klyrSpongePlan(months);
      const fresh = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' }).then(r => r.json());
      for (const sponge of fresh.items) {
        const plan = sponge.selling_plan_allocation?.selling_plan.id;
        if (line.product_id !== 15621417795908 && sponge.id === SPONGE_VARIANT_ID && plan && spongePlan && plan !== spongePlan) {
          await this.switchPlan(sponge, sponge.quantity, spongePlan);
        }
      }
    }
    return fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' }).then(r => r.json());
  }

  updateQuantity(lineKey, quantity, row) {
    this.toggleLoader(lineKey, true);

    const productId  = parseInt(row?.dataset.productId, 10);

    if (SCP_PRODUCT_IDS.includes(productId)) {
      this.updateScpQuantity(lineKey, quantity)
        .then(cart => {
          this.emitCartUpdated(cart);
          this.toggleLoader(lineKey, false);
        })
        .catch(err => console.error("Update cart (Skin Corrector) failed:", err));
      return;
    }

    const currentPlan = parseInt(row?.dataset.sellingPlan, 10);
    const isSubProduct = SUB_PLAN_HOST_IDS.includes(productId) && currentPlan;
    const correctPlan  = quantity >= 2 ? SELLING_PLAN_TWO : SELLING_PLAN_ONE;
    const needsPlanSwitch = isSubProduct && quantity > 0 && currentPlan !== correctPlan;

    if (needsPlanSwitch) {
      const variantId = parseInt(row?.dataset.itemId, 10);
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(() => fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity, selling_plan: correctPlan })
        }))
        .then(() => fetch(`${window.Shopify.routes.root}cart.js`).then(r => r.json()))
        .then(cart => {
          this.emitCartUpdated(cart);
          this.toggleLoader(lineKey, false);
        })
        .catch(err => console.error("Update cart (plan switch) failed:", err));
    } else {
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      })
        .then(res => res.json())
        .then(cart => {
          this.emitCartUpdated(cart);
          this.toggleLoader(lineKey, false);
        })
        .catch(err => console.error("Update cart failed:", err));
    }
  }


  rerenderCart(cart) {
    const sectionId = document.querySelector('#header-component')?.dataset.sectionId;
    if (!sectionId) return;

    const url = new URL(window.Shopify.routes.root, window.location.origin);
    url.searchParams.set('sections', sectionId);
    if (window.Shopify.theme && window.Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    fetch(url, { cache: 'no-store' })
      .then(res => res.json())
      .then(data => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data[sectionId];
        const newContent = tempDiv.querySelector('.cart-drawer__inner');
        const newCartCount = tempDiv.querySelector('.header-cart__icon-text .cart-text');
        if (newContent) this.drawer.innerHTML = newContent.innerHTML;
        if (newCartCount) document.querySelector('.header-cart__icon-text .cart-text').innerHTML = newCartCount.innerHTML;
      })
      .catch(err => console.error("Failed to reload cart drawer:", err));
  }

  emitCartUpdated(cart) {
    // Trigger custom event for other classes to listen
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }
}


// ✅ Initialize
const cartDrawer = new CustomCartDrawer('.cart-drawer__inner');

// Keep subscribed sponges on the exact plan of the Skin Corrector bottles (never on an old sponge plan).
(() => {
  let busy = false;
  document.addEventListener('cart:updated', async (event) => {
    const cart = event.detail;
    if (busy || !cart || !Array.isArray(cart.items) || !cartDrawer.drawer) return;
    const bottle = cart.items.find(item => SCP_PRODUCT_IDS.includes(item.product_id) && SCP_PLAN_IDS.includes(item.selling_plan_allocation?.selling_plan.id));
    const bottlePlan = bottle ? bottle.selling_plan_allocation.selling_plan.id : null;
    const fixes = cart.items
      .filter(item => item.id === SPONGE_VARIANT_ID && item.selling_plan_allocation)
      .map(item => {
        const plan = item.selling_plan_allocation.selling_plan.id;
        const target = bottlePlan || (OLD_SPONGE_PLAN_MONTHS[plan] ? SCP_PLANS[OLD_SPONGE_PLAN_MONTHS[plan]] : null);
        return target && target !== plan ? { item, target } : null;
      })
      .filter(Boolean);
    if (!fixes.length) return;
    busy = true;
    try {
      for (const fix of fixes) await cartDrawer.switchPlan(fix.item, fix.item.quantity, fix.target);
      const fresh = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' }).then(r => r.json());
      busy = false;
      cartDrawer.emitCartUpdated(fresh);
    } catch (error) {
      console.error('Sponge plan sync failed', error);
    } finally {
      busy = false;
    }
  });
})();
